import { RefObject, useEffect, useState } from 'react';

interface Size {
	inlineSize: number;
	blockSize: number;
}

function useResizeObserver<T extends HTMLElement>(ref: RefObject<T | null>): Size | undefined {
	const [size, setSize] = useState<Size>();

	useEffect(() => {
		const element = ref.current;
		if (!element) return undefined;

		const observer = new ResizeObserver((entries) => {
			const entry = entries[0];
			if (entry) {
				const { inlineSize, blockSize } = entry.borderBoxSize[0];
				setSize((prev) =>
					prev && prev.inlineSize === inlineSize && prev.blockSize === blockSize
						? prev
						: { inlineSize, blockSize }
				);
			}
		});
		observer.observe(element);

		return () => observer.disconnect();
	}, [ref]);

	return size;
}

export default useResizeObserver;
